import { render, staticRenderFns } from "./IconMeal.vue?vue&type=template&id=5427d1ca&scoped=true"
import script from "./IconMeal.vue?vue&type=script&lang=js"
export * from "./IconMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427d1ca",
  null
  
)

export default component.exports